import { addressApi } from '../api'

const getAllStates = async () => {
  try {
    const response = await addressApi.getAllStates()

    const { ok, status } = response

    if (ok && status === 200) {
      const responseBody = await response.json()

      const states = responseBody.data.map(({ id, attributes: a }) => ({
        value: id,
        label: a.acronym,
      }))

      return {
        success: true,
        payload: { states },
      }
    }
  } catch {}

  return { success: false, payload: { states: [] }, error: 'UnhandledError' }
}

const getCitiesByState = async stateId => {
  try {
    const response = await addressApi.getCitiesByState(stateId)

    const { ok, status } = response

    if (ok && status === 200) {
      const responseBody = await response.json()

      const cities = responseBody.data.map(({ id, attributes: a }) => ({
        ...a,
        value: id,
        label: a.name,
      }))

      return {
        success: true,
        payload: { cities },
      }
    }
  } catch {}

  return { success: false, payload: { cities: [] }, error: 'UnhandledError' }
}

const searchAddressByCityAndZipCodeOrStreet = async (cityId, term) => {
  try {
    const response = await addressApi.searchByCity(cityId, term)

    const { ok, status } = response

    if (ok && [200, 304].includes(status)) {
      const responseBody = await response.json()

      const addresses = responseBody.data.map(({ id, attributes: a }) => ({
        ...a,
        id,
        name: a.label,
      }))

      return {
        success: true,
        payload: { addresses },
      }
    }
  } catch {}

  return { success: false, payload: { addresses: [] }, error: 'UnhandledError' }
}

const searchAddressByZipcode = async zipcode => {
  try {
    const response = await addressApi.searchByZipcode(zipcode)

    const { ok, status } = response

    if (ok && status === 200) {
      const responseBody = await response.json()

      const data = Array.isArray(responseBody.data)
        ? responseBody.data
        : responseBody.data
          ? [responseBody.data]
          : []

      const items = data.map(({ id, type, attributes: a }) => ({
        ...a,
        id,
        type,
        name: a.label || '',
      }))

      const unifiedCity = items.find(i => i.type === 'city')

      const meta = responseBody.meta || {}
      const outsideZone = !!meta.outside_zone

      if (unifiedCity) {
        return {
          success: true,
          payload: {
            unifiedCity,
            addresses: [],
            outsideZone: false,
            source: 'unifiedCity',
            neighborhoods: [],
          },
        }
      }

      // Endereços Extras (chamada "Apenas do zoneamento"): o bairro e o
      // logradouro são escolhidos entre os cadastros do CEP.
      const isWeakStreet =
        meta.source === 'weak_street' ||
        (items.length > 0 && items.every(i => i.type === 'weakStreet'))

      return {
        success: true,
        payload: {
          addresses: items,
          unifiedCity: null,
          outsideZone,
          source: isWeakStreet ? 'weakStreet' : 'street',
          neighborhoods: isWeakStreet ? meta.neighborhoods || [] : [],
        },
      }
    }
  } catch {}

  return {
    success: false,
    payload: {
      addresses: [],
      unifiedCity: null,
      outsideZone: false,
      source: null,
      neighborhoods: [],
    },
    error: 'UnhandledError',
  }
}

const addressService = {
  getAllStates,
  getCitiesByState,
  searchAddressByCityAndZipCodeOrStreet,
  searchAddressByZipcode,
}

export default addressService
